import { useDeveloperContext } from '@/hooks/useDeveloperContext';
import { DeveloperCustomersList } from '@/components/dashboard/developer/DeveloperCustomersList';

export default function DeveloperCustomers() {
  const { ctx } = useDeveloperContext();
  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-display text-xl font-bold">Customers</h2>
        <p className="text-sm text-muted-foreground">
          {ctx.isAdmin ? 'All leads across your projects.' : 'Leads in your developer workspace.'}
        </p>
      </div>
      <DeveloperCustomersList scope={ctx.isAdmin ? 'workspace' : 'mine'} />
    </div>
  );
}
